import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { requestEmailSignature } from './actions';
import { getEmailSignature } from './reducer';
import { getUser } from '../../modules/Auth/AuthReducer';

class CheckUserEmailSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (!this.props.loaded && !this.props.loading) {
      this.loadSignature(this.props.user.email);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loaded && !nextProps.loading && !nextProps.error) {
      this.loadSignature(nextProps.user.email);
    }
  }

  loadSignature(email) {
    this.props.dispatch(requestEmailSignature(email));
  }

  render() {
    const {
      children, loading, loaded,
      verified, error,
    } = this.props;
    const props = {
      loading, loaded, verified, error,
    };
    const comp = children !== null ? children(props) : null;
    return comp;
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const user = getUser(state);
  const info = getEmailSignature(state, user.email);
  return {
    verified: info.signature === 'verified',
    sent: info.signature === 'sent',
    loaded: info.status === 'loaded',
    loading: info.status === 'loading',
    error: info.status === 'error',
    user,
  };
}

CheckUserEmailSignature.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.func,
  verified: PropTypes.bool,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  error: PropTypes.bool,
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
};
CheckUserEmailSignature.defaultProps = {
  children: null,
  verified: false,
  loading: false,
  loaded: false,
  error: false,
};


export default connect(mapStateToProps)(CheckUserEmailSignature);
